export default "__VITE_ASSET__Btj5T1pa__"